<template>
  <v-container>
    <v-btn @click="newOrder" class="my-3 mr-3">Nueva Orden</v-btn>
    <template v-if="order">

      <print-ticket
          ref="printer"
          :disabled="!order"
          :order="order"
          :small="false"
          :icon="false"
          class="mx-2 green"
      ></print-ticket>

      <print-ticket
          ref="printer"
          :disabled="!order"
          :order="order"
          :small="false"
          :icon="false"
          :drink="false"
          class="mx-2 red"
      ></print-ticket>

      <print-ticket
          ref="printer"
          :disabled="!order"
          :order="order"
          :small="false"
          :icon="false"
          :drink="true"
          class="mx-2 blue"
      ></print-ticket>
    </template>



    <v-divider></v-divider>
    <show-order :identifier="identifier" />
  </v-container>
</template>

<script>
import PrintTicket from "@/modules/delivery/components-core/business/PrintTicket/PrintTicket.vue";
import ShowOrder from "@/modules/delivery/components-core/shared/ShowOrder/ShowOrder.vue";
import OrderProvider from "@/modules/delivery/providers/OrderProvider";

export default {
  name: "BarOrderViewPage",
  components: { ShowOrder, PrintTicket },
  computed: {
    identifier() {
      return this.$route.params.identifier;
    },
    isSalon(){
      return this.$route.name === "SalonOrderViewPage";
    }
  },
  data() {
    return {
      order: null,
    };
  },
  created() {
    this.fetchOrder();
  },
  methods: {
    newOrder() {
      if (this.isSalon) {
        this.$router.push({ name: "SalonOrderPage" });
      } else {
        this.$router.push({ name: "BarOrderPage" });
      }
    },
    async fetchOrder() {
      let r = await OrderProvider.orderFindByIdentifier(this.identifier);
      this.order = r.data.orderFindByIdentifier;
    },
  },
};
</script>

<style scoped></style>
